export class RoutingLogQuery {
    key: string;
}


export class RoutingLogDetails {

    username: string;
    timestamp: string;
    activityType: string;
    note: string;
    executionType: string;

    constructor(details: Partial<RoutingLogDetails>) {
        if (details != null) {
            this.username = details.username;
            this.timestamp = details.timestamp;
            this.activityType = details.activityType;
            this.note = details.note;
            this.executionType = details.executionType;
        }
    }
}
